// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Tutorial Overlay and Highlight */
.tutorial-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 9998;
  pointer-events: none;
}

.tutorial-highlight {
  position: fixed;
  border: 3px solid #4CAF50;
  border-radius: 8px;
  box-shadow: 0 0 0 4px rgba(76, 175, 80, 0.3),
              0 0 20px rgba(76, 175, 80, 0.5);
  animation: pulse 2s infinite;
  pointer-events: none;
  z-index: 9999;
  background: transparent;
}

@keyframes pulse {
  0%, 100% {
    box-shadow: 0 0 0 4px rgba(76, 175, 80, 0.3),
                0 0 20px rgba(76, 175, 80, 0.5);
  }
  50% {
    box-shadow: 0 0 0 8px rgba(76, 175, 80, 0.2),
                0 0 30px rgba(76, 175, 80, 0.7);
  }
}

/* Tutorial Box */
.tutorial-box {
  position: fixed;
  width: 350px;
  max-width: 90vw;
  background: linear-gradient(135deg, #1a1a2e 0%, #16213e 100%);
  border: 2px solid #4CAF50;
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.5);
  z-index: 10000;
  overflow: hidden;
}

.tutorial-box.dragging {
  cursor: move;
  opacity: 0.9;
}

.tutorial-header {
  background: linear-gradient(90deg, #4CAF50 0%, #45a049 100%);
  padding: 12px 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: move;
  -webkit-user-select: none;
          user-select: none;
}

.tutorial-header h3 {
  margin: 0;
  color: white;
  font-size: 16px;
  font-weight: 600;
}

.tutorial-close {
  background: rgba(255, 255, 255, 0.2);
  border: none;
  color: white;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  transition: background 0.2s;
}

.tutorial-close:hover {
  background: rgba(255, 255, 255, 0.3);
}

.tutorial-content {
  padding: 16px;
  color: #e0e0e0;
  font-size: 14px;
  line-height: 1.6;
  max-height: 400px;
  overflow-y: auto;
}

.tutorial-content p {
  margin: 0 0 12px 0;
  white-space: pre-line;
}

.tutorial-content p:last-child {
  margin-bottom: 0;
}

.tutorial-content strong {
  color: #4CAF50;
  font-weight: 600;
}

.tutorial-footer {
  padding: 12px 16px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.tutorial-progress {
  text-align: center;
  color: #888;
  font-size: 12px;
}

.tutorial-buttons {
  display: flex;
  gap: 8px;
  justify-content: flex-end;
}

.tutorial-btn {
  padding: 8px 16px;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  white-space: nowrap;
}

.tutorial-btn-primary {
  background: #4CAF50;
  color: white;
}

.tutorial-btn-primary:hover {
  background: #45a049;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(76, 175, 80, 0.3);
}

.tutorial-btn-primary:disabled {
  background: #666;
  cursor: not-allowed;
  transform: none;
}

.tutorial-btn-secondary {
  background: rgba(255, 255, 255, 0.1);
  color: white;
}

.tutorial-btn-secondary:hover {
  background: rgba(255, 255, 255, 0.15);
}

.tutorial-btn-success {
  background: linear-gradient(90deg, #4CAF50 0%, #45a049 100%);
  color: white;
  padding: 10px 20px;
  font-size: 15px;
  font-weight: 600;
}

.tutorial-btn-success:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(76, 175, 80, 0.4);
}

.tutorial-btn-danger {
  background: #f44336;
  color: white;
}

.tutorial-btn-danger:hover {
  background: #da190b;
}

/* Skip Confirmation Modal */
.tutorial-skip-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10001;
}

.tutorial-skip-modal {
  background: linear-gradient(135deg, #1a1a2e 0%, #16213e 100%);
  border: 2px solid #f44336;
  border-radius: 12px;
  padding: 24px;
  width: 400px;
  max-width: 90vw;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.5);
}

.tutorial-skip-modal h3 {
  margin: 0 0 16px 0;
  color: white;
  font-size: 20px;
}

.tutorial-skip-modal p {
  margin: 0 0 12px 0;
  color: #e0e0e0;
  font-size: 14px;
  line-height: 1.6;
}

.tutorial-warning {
  color: #f44336 !important;
  font-weight: 600;
}

.tutorial-skip-buttons {
  display: flex;
  gap: 12px;
  margin-top: 20px;
  justify-content: flex-end;
}

/* Mobile Responsive */
@media (max-width: 768px) {
  .tutorial-box {
    width: 320px;
    max-width: calc(100vw - 20px);
  }

  .tutorial-content {
    font-size: 13px;
    max-height: 300px;
  }

  .tutorial-header h3 {
    font-size: 15px;
  }

  .tutorial-btn {
    padding: 7px 12px;
    font-size: 13px;
  }

  .tutorial-skip-modal {
    width: 320px;
    padding: 20px;
  }
}

/* Scrollbar styling */
.tutorial-content::-webkit-scrollbar {
  width: 6px;
}

.tutorial-content::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.05);
  border-radius: 3px;
}

.tutorial-content::-webkit-scrollbar-thumb {
  background: rgba(76, 175, 80, 0.5);
  border-radius: 3px;
}

.tutorial-content::-webkit-scrollbar-thumb:hover {
  background: rgba(76, 175, 80, 0.7);
}
`, "",{"version":3,"sources":["webpack://./src/components/Tutorial.css"],"names":[],"mappings":"AAAA,mCAAmC;AACnC;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB;6CAC2C;EAC3C,4BAA4B;EAC5B,oBAAoB;EACpB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE;IACE;+CAC2C;EAC7C;EACA;IACE;+CAC2C;EAC7C;AACF;;AAEA,iBAAiB;AACjB;EACE,eAAe;EACf,YAAY;EACZ,eAAe;EACf,6DAA6D;EAC7D,yBAAyB;EACzB,mBAAmB;EACnB,yCAAyC;EACzC,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,4DAA4D;EAC5D,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,YAAY;EACZ,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,8CAA8C;EAC9C,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,oCAAoC;EACpC,YAAY;AACd;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,4DAA4D;EAC5D,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA,4BAA4B;AAC5B;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,6DAA6D;EAC7D,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,eAAe;EACf,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA,sBAAsB;AACtB;EACE;IACE,YAAY;IACZ,6BAA6B;EAC/B;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,aAAa;EACf;AACF;;AAEA,sBAAsB;AACtB;EACE,UAAU;AACZ;;AAEA;EACE,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;AACpC","sourcesContent":["/* Tutorial Overlay and Highlight */\n.tutorial-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 9998;\n  pointer-events: none;\n}\n\n.tutorial-highlight {\n  position: fixed;\n  border: 3px solid #4CAF50;\n  border-radius: 8px;\n  box-shadow: 0 0 0 4px rgba(76, 175, 80, 0.3),\n              0 0 20px rgba(76, 175, 80, 0.5);\n  animation: pulse 2s infinite;\n  pointer-events: none;\n  z-index: 9999;\n  background: transparent;\n}\n\n@keyframes pulse {\n  0%, 100% {\n    box-shadow: 0 0 0 4px rgba(76, 175, 80, 0.3),\n                0 0 20px rgba(76, 175, 80, 0.5);\n  }\n  50% {\n    box-shadow: 0 0 0 8px rgba(76, 175, 80, 0.2),\n                0 0 30px rgba(76, 175, 80, 0.7);\n  }\n}\n\n/* Tutorial Box */\n.tutorial-box {\n  position: fixed;\n  width: 350px;\n  max-width: 90vw;\n  background: linear-gradient(135deg, #1a1a2e 0%, #16213e 100%);\n  border: 2px solid #4CAF50;\n  border-radius: 12px;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.5);\n  z-index: 10000;\n  overflow: hidden;\n}\n\n.tutorial-box.dragging {\n  cursor: move;\n  opacity: 0.9;\n}\n\n.tutorial-header {\n  background: linear-gradient(90deg, #4CAF50 0%, #45a049 100%);\n  padding: 12px 16px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  cursor: move;\n  user-select: none;\n}\n\n.tutorial-header h3 {\n  margin: 0;\n  color: white;\n  font-size: 16px;\n  font-weight: 600;\n}\n\n.tutorial-close {\n  background: rgba(255, 255, 255, 0.2);\n  border: none;\n  color: white;\n  width: 28px;\n  height: 28px;\n  border-radius: 50%;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 18px;\n  transition: background 0.2s;\n}\n\n.tutorial-close:hover {\n  background: rgba(255, 255, 255, 0.3);\n}\n\n.tutorial-content {\n  padding: 16px;\n  color: #e0e0e0;\n  font-size: 14px;\n  line-height: 1.6;\n  max-height: 400px;\n  overflow-y: auto;\n}\n\n.tutorial-content p {\n  margin: 0 0 12px 0;\n  white-space: pre-line;\n}\n\n.tutorial-content p:last-child {\n  margin-bottom: 0;\n}\n\n.tutorial-content strong {\n  color: #4CAF50;\n  font-weight: 600;\n}\n\n.tutorial-footer {\n  padding: 12px 16px;\n  border-top: 1px solid rgba(255, 255, 255, 0.1);\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.tutorial-progress {\n  text-align: center;\n  color: #888;\n  font-size: 12px;\n}\n\n.tutorial-buttons {\n  display: flex;\n  gap: 8px;\n  justify-content: flex-end;\n}\n\n.tutorial-btn {\n  padding: 8px 16px;\n  border: none;\n  border-radius: 6px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n  white-space: nowrap;\n}\n\n.tutorial-btn-primary {\n  background: #4CAF50;\n  color: white;\n}\n\n.tutorial-btn-primary:hover {\n  background: #45a049;\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(76, 175, 80, 0.3);\n}\n\n.tutorial-btn-primary:disabled {\n  background: #666;\n  cursor: not-allowed;\n  transform: none;\n}\n\n.tutorial-btn-secondary {\n  background: rgba(255, 255, 255, 0.1);\n  color: white;\n}\n\n.tutorial-btn-secondary:hover {\n  background: rgba(255, 255, 255, 0.15);\n}\n\n.tutorial-btn-success {\n  background: linear-gradient(90deg, #4CAF50 0%, #45a049 100%);\n  color: white;\n  padding: 10px 20px;\n  font-size: 15px;\n  font-weight: 600;\n}\n\n.tutorial-btn-success:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 20px rgba(76, 175, 80, 0.4);\n}\n\n.tutorial-btn-danger {\n  background: #f44336;\n  color: white;\n}\n\n.tutorial-btn-danger:hover {\n  background: #da190b;\n}\n\n/* Skip Confirmation Modal */\n.tutorial-skip-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.8);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 10001;\n}\n\n.tutorial-skip-modal {\n  background: linear-gradient(135deg, #1a1a2e 0%, #16213e 100%);\n  border: 2px solid #f44336;\n  border-radius: 12px;\n  padding: 24px;\n  width: 400px;\n  max-width: 90vw;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.5);\n}\n\n.tutorial-skip-modal h3 {\n  margin: 0 0 16px 0;\n  color: white;\n  font-size: 20px;\n}\n\n.tutorial-skip-modal p {\n  margin: 0 0 12px 0;\n  color: #e0e0e0;\n  font-size: 14px;\n  line-height: 1.6;\n}\n\n.tutorial-warning {\n  color: #f44336 !important;\n  font-weight: 600;\n}\n\n.tutorial-skip-buttons {\n  display: flex;\n  gap: 12px;\n  margin-top: 20px;\n  justify-content: flex-end;\n}\n\n/* Mobile Responsive */\n@media (max-width: 768px) {\n  .tutorial-box {\n    width: 320px;\n    max-width: calc(100vw - 20px);\n  }\n\n  .tutorial-content {\n    font-size: 13px;\n    max-height: 300px;\n  }\n\n  .tutorial-header h3 {\n    font-size: 15px;\n  }\n\n  .tutorial-btn {\n    padding: 7px 12px;\n    font-size: 13px;\n  }\n\n  .tutorial-skip-modal {\n    width: 320px;\n    padding: 20px;\n  }\n}\n\n/* Scrollbar styling */\n.tutorial-content::-webkit-scrollbar {\n  width: 6px;\n}\n\n.tutorial-content::-webkit-scrollbar-track {\n  background: rgba(255, 255, 255, 0.05);\n  border-radius: 3px;\n}\n\n.tutorial-content::-webkit-scrollbar-thumb {\n  background: rgba(76, 175, 80, 0.5);\n  border-radius: 3px;\n}\n\n.tutorial-content::-webkit-scrollbar-thumb:hover {\n  background: rgba(76, 175, 80, 0.7);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
